import * as atcClassifications from './atcClassifications'
import * as auth from './auth'
import * as user from './user'
import * as imagesTime from './imagesTime'
import * as interactions from './interactions'
import * as interactionsType from './interactionsType'
import * as laboratories from './laboratories'
import * as medications from './medications'
import * as severities from './severities'
import * as medicationsClassification from './medicationsClassification'
import * as specialities from './specialities'
import * as authors from './authors'
import * as content from './content'
import * as keywords from './keywords'
import * as namesDcb from './namesDcb'
import * as probabilities from './probabilities'
import * as ratings from './ratings'
import * as preRegistrations from './preRegistrations'
import * as profiles from './profiles'
import * as medicationsTypes from './medicationsTypes'
import * as references from './references'
import * as gruposConteudo from './gruposConteudo'
import * as publicosAlvo from './publicosAlvo'
import * as readingTimes from './readingTimes'
import * as cids from './cids'
import * as bookVectorization from './bookVectorization'
import * as contentVectorization from './contentVectorization'

export {
  atcClassifications,
  auth,
  user,
  imagesTime,
  interactions,
  interactionsType,
  laboratories,
  medications,
  severities,
  specialities,
  medicationsClassification,
  authors,
  keywords,
  namesDcb,
  ratings,
  content,
  gruposConteudo,
  publicosAlvo,
  preRegistrations,
  profiles,
  medicationsTypes,
  references,
  probabilities,
  readingTimes,
  cids,
  bookVectorization,
  contentVectorization,
}



// WEBPACK FOOTER //
// ./src/api/index.js